import { Template } from "../../../../../core/template/index";
import { FortumApp } from "../../../../fortumApp";
import { ScannedItemView } from "../../scan_packages/scanned_item";
import { splitItemCode } from "../../../../helpers";


export class CollectForDeliveryItemView extends ScannedItemView {

    app: FortumApp;
    template = Template.lazy('/app/views/package_tracking/collect_for_delivery/item/index.html');

    firstRender: boolean = true;
    itemDescription: HTMLElement;
    itemNumber: HTMLElement;
    isTransportationUnit: Boolean;

    public updateItemData(data)
    {
        this.element.classList.add('success');
        this.element.classList.remove('loading');
        if (this.isTransportationUnit == true) {
            this.itemDescription.textContent = data.name;
            this.itemNumber.textContent = data.id;
        } else {
            this.itemDescription.textContent = data.item_description;
            this.itemNumber.textContent = data.item;
        }
        this.item = Object.assign({}, data);
    }

    public render(to: HTMLElement) {
        if (this.firstRender) {
            this.firstRender = false;
        } else {
            this.element.classList.remove('success');
        }
        to.insertAdjacentElement('beforeend', this.element);
    }

    protected constructItem(data) {
        // Start loading as soon as possible
        if (data.fetch_tag) {
            const splitted = splitItemCode(data.fetch_tag);
            if (splitted) {
                // Try to load local data first
                this.dataLoader = this.app.db.DeliveryNoteItem.get(parseInt(splitted[1])).then(item => {
                    if (item) {
                        return item;
                    } else {
                        // Local data not available, go to network
                        return this.app.api.private('pt_delivery_note_item_info', {package_tag: data.fetch_tag});
                    }
                });
            } else {
                this.dataLoader = Promise.reject(new Error(this.pgettext('Error', 'Invalid package label')));
            }
        } else {
            this.dataLoader = Promise.resolve(data);
        }
    }

    public onDeleteClick() {
        this.trigger('delete', this);
    }

    protected onDataLoadedSuccessfully(data: any) {
        this.updateItemData(data);
    }
    
    protected onDataLoadError(error: any) {
        this.app.toasts.show(this.pgettext('Message', 'Delivery item not found!'));
    }

}